module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAA2UExURUdwTBQAJBUBJRYAJg4AIBYCJhYCJhIAIhYAJhQCJBQAJBQCJBYAJhYCJhQCJBYCJhYCJhYCJs2p2tkAAAARdFJOUwA+f5ES79FAoGAwsE9wXr/BWMpSIwAAAOBJREFUOMvt1MkSgyAMAFBaVtmc/P/PFoMIghhn2mNzUGEei0wCY31EBaAio0I4wHCCgAbAaJ2eK+mW7b0k/8RRsrp72bo7eXZzyTuHko/uarwZxs7WMVermG/2/fwknp9tKy2RAStIi06Cus0poVAKymUp0hYoh9IwAE+mPfMgmYRAw5AgzyUyR7mIOBNZzmF2+B86NDC+MWIDgy7fukIDe/AKD9fCJLYJTdszgWPPH/4aNkk5QH9KGHeU1wDXUwqmQlT+tUWF2PTp5rfdVVGiwBLd5WOdzP0qt/eWdGW+D68xFZ6DygF3AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/h5/tabBar_icon_01.png
// module id = t9pG
// module chunks = 34